const carbody = {
  product_item: 'Product',
  product_list_empty: 'No products. Press + to add.',
  save_all: 'Save all',
  add_product: 'Add product',
  cati_code: 'CATI code',
  supplier_product_code: 'Supplier product code',
  supplier_cost_label: 'Cost',
  supplier_barcode_label: 'Barcode',
  description: 'Description',
  ean: 'EAN code',
  EAN: 'EAN',
  OEM: 'OEM',
  quality: 'Quality',
  quality_label: 'Product quality',
  quality_hint:
    'Value imported from the master list (Qualità column) — e.g. E, Q; leave blank if not present.',
  is_partial_catalogue: 'Partial load',
  price_save_success: 'Price updated successfully',
  code_save_success: 'Product code updated successfully',
  code_edit_confirm_immediate:
    'If you confirm, the code will be removed right away from every CATI product listed, together with its price for this supplier, and assigned to this row.',
  partial_future_date_error: 'Partial mode does not allow a future date',
  cati_code_taken: 'CATI code already exists',
  cati_code_dup_in_batch:
    'Duplicate CATI code among the products being created',
  batch_create_success: 'Products created: {count}',
  batch_create_errors: 'Some products could not be created',
  future_mode_note:
    'Future mode: the live catalog will not be modified; price takes effect from the selected date',
  tmp_not_found_error: 'No imported price found for this supplier / code',
  show_hidden: 'Show hidden',
  hide_product: 'Hide',
  unhide_product: 'Show',
  row_actions: 'Actions',
  row_actions_title: 'Product actions',
  create_new_from_tmp: 'Create new product',
  update_existing_product: 'Update existing product',
  export_xlsx: 'Export XLSX',

  // ── /carbody/prices filter bar — free-text search ─────────────────────────
  // Matches the supplier's PRODUCT code (`car_body_products.code`, the grid's
  // "Codice prodotto"), not the supplier's registry code.
  index_search_label: 'Search by supplier product code',

  // ── "ESPORTA" (carbody/prices) format picker ──────────────────────────────
  export_format_csv: 'CSV',
  export_format_xlsx: 'Excel (.xlsx)',
  oem_match_modal_title: 'OEM already present',
  oem_match_modal_body:
    'A product from the same supplier with the same OEM was found. Do you want to copy the descriptive data?',
  oem_match_modal_note:
    'The following will be filled in: description, EAN, category, class, and OEM list. CATI code and supplier code will not be changed.',
  oem_match_confirm: 'Yes, fill in',
  oem_match_cancel: 'No, keep',

  // ── Catalogue master sync (task 2026-08-28-014) ──────────────────────────
  catalogue_sync_new_title: 'New catalogue sync',
  catalogue_sync_upload_label: 'Select the master catalogue file',
  catalogue_sync_upload_hint:
    '.xlsx or .csv master catalogue file (about 50 MB)',
  catalogue_sync_uploading: 'Uploading…',
  catalogue_sync_upload_success: 'File uploaded: {name}',
  catalogue_sync_upload_size: 'Size: {size}',
  catalogue_sync_header_ok: 'File structure verified',
  catalogue_sync_header_ko_title:
    'The file does not have the expected structure',
  catalogue_sync_header_ko_message: 'Missing columns in the uploaded file:',
  catalogue_sync_reupload: 'Upload a different file',
  catalogue_sync_options_title: 'Options',
  catalogue_sync_mode_label: 'Mode',
  catalogue_sync_mode_dry_run: 'Simulation',
  catalogue_sync_mode_write: 'Write',
  catalogue_sync_price_date_label: 'Price validity date',
  catalogue_sync_prune_links_label:
    'Remove product-vehicle links no longer present in the file',
  catalogue_sync_advanced_toggle: 'Advanced options',
  catalogue_sync_chunk_size_label: 'Processing chunk size',
  catalogue_sync_chunk_size_hint:
    'Between 200 and 5000, default 2000. Change only if instructed by technical support.',
  catalogue_sync_stages_label: 'Stages to run',
  catalogue_sync_stages_hint:
    'Leave all stages selected unless told otherwise by technical support.',
  catalogue_sync_stage_parse: 'File parsing',
  catalogue_sync_stage_cars: 'Cars',
  catalogue_sync_stage_links: 'Product-vehicle links',
  catalogue_sync_stage_info: 'Product info',
  catalogue_sync_stage_prices: 'Prices',
  catalogue_sync_simulate_button: 'Simulate',
  catalogue_sync_write_button: 'Run',
  catalogue_sync_write_confirm_title: 'Confirm write',
  catalogue_sync_write_confirm_message:
    'This will rewrite the CarBody catalogue (cars, links, product info and prices) from the uploaded file. Continue?',
  catalogue_sync_write_confirm_checkbox: 'I confirm I want to start the write',
  catalogue_sync_write_confirm_button: 'Start write',
  catalogue_sync_start_error_locked: 'A sync is already in progress.',
  catalogue_sync_start_error_locked_action: 'Go to history',
  catalogue_sync_run_started: 'Sync started',
  catalogue_sync_status_title: 'Sync status',
  catalogue_sync_status_queued: 'Queued',
  catalogue_sync_status_queued_hint:
    'Waiting for a free worker — this can take a moment.',
  catalogue_sync_status_running: 'Running',
  catalogue_sync_status_completed: 'Completed',
  catalogue_sync_status_failed: 'Failed',
  catalogue_sync_status_cancelled: 'Cancelled',
  catalogue_sync_elapsed: 'Elapsed: {time}',
  catalogue_sync_stage_progress: 'Stage {index} of {count}: {stage}',
  catalogue_sync_counters_title: 'Counters',
  catalogue_sync_suppliers_title: 'Suppliers',
  catalogue_sync_error_title: 'Error',
  catalogue_sync_cancelled_note:
    'Chunks already committed are not rolled back.',
  catalogue_sync_cancel_button: 'Cancel',
  catalogue_sync_cancel_confirm_message:
    'Cancellation is cooperative: chunks already saved will not be reverted. Continue?',
  catalogue_sync_cancel_requested: 'Cancellation requested',
  catalogue_sync_resume_button: 'Resume',
  catalogue_sync_resume_confirm_message:
    'Resume the sync from where it stopped?',
  catalogue_sync_resume_requested: 'Resume requested',
  catalogue_sync_report_summary_button: 'Download summary',
  catalogue_sync_report_skipped_button: 'Download skipped rows',
  catalogue_sync_write_from_dry_run_button: 'Run the write with this file',
  catalogue_sync_write_from_dry_run_unavailable:
    "This run's source file is no longer available, so the write cannot be started from here.",
  catalogue_sync_stale_warning:
    'No progress detected for {minutes} minutes: the sync may be stuck. If this persists, contact technical support.',
  catalogue_sync_closing_tab_note:
    'You can close this page: the sync keeps running on the server. Find its status again from the history.',
  catalogue_sync_history_title: 'Sync history',
  catalogue_sync_history_new_button: 'New sync',
  catalogue_sync_history_empty: 'No sync has been run yet.',
  catalogue_sync_history_col_date: 'Date',
  catalogue_sync_history_col_user: 'User',
  catalogue_sync_history_col_mode: 'Mode',
  catalogue_sync_history_col_status: 'Status',
  catalogue_sync_history_col_duration: 'Duration',
  catalogue_sync_history_col_actions: 'Actions',
  catalogue_sync_history_view_action: 'View detail',
  catalogue_sync_upload_missing_no_columns:
    'The file does not have the expected format.',
  catalogue_sync_counter_rows_read: 'Rows read',
  catalogue_sync_counter_rows_skipped_header_or_blank:
    'Rows skipped (header/blank)',
  catalogue_sync_counter_code_blank: 'Blank code',
  catalogue_sync_counter_products_matched: 'Products matched',
  catalogue_sync_counter_products_not_found: 'Products not found',
  catalogue_sync_counter_cars_matched: 'Cars already present',
  catalogue_sync_counter_cars_created: 'Cars created',
  catalogue_sync_counter_cars_not_created: 'Cars not created',
  catalogue_sync_counter_links_deleted: 'Links removed',
  catalogue_sync_counter_links_inserted: 'Links inserted',
  catalogue_sync_counter_info_written: 'Product info updated',
  catalogue_sync_counter_status_cleared: 'Statuses cleared',
  catalogue_sync_counter_details_written: 'Details updated',
  catalogue_sync_counter_prices_written: 'Prices updated',
  catalogue_sync_counter_prices_skipped: 'Prices skipped',
  catalogue_sync_counter_oems_written: 'OEMs updated',
  catalogue_sync_counter_categories_rejected: 'Categories rejected',
  catalogue_sync_counter_values_truncated: 'Values truncated',
  catalogue_sync_counter_classe_mismatches: 'Class mismatches',
  catalogue_sync_counter_car_label_blank: 'Blank vehicle label',
  catalogue_sync_counter_prices_not_numeric: 'Non-numeric prices',
  catalogue_sync_counter_prices_code_only: 'Incomplete code/price pairs',
  catalogue_sync_counter_dates_unparseable: 'Unparseable dates',
  catalogue_sync_counter_suppliers_not_listed: 'Suppliers not on list',
  catalogue_sync_counter_descrizione_conflicts: 'Conflicting descriptions',
  catalogue_sync_counter_cod_oem_conflicts: 'Conflicting OEM codes',
  catalogue_sync_counter_ultimo_aggiornamento_conflicts: 'Conflicting update dates',
  catalogue_sync_supplier_col_name: 'Supplier',

  // ── Order export catalogue (drag-to-reorder, block-local) ────────────────
  catalogue_order_col_code: 'Code',
  catalogue_order_col_description: 'Description',
  catalogue_order_col_quality: 'Quality',
  catalogue_order_col_category: 'Category',
  catalogue_order_col_status: 'Status',
  catalogue_order_col_oem: 'OEM',
  catalogue_order_block_unpositioned: 'Not positioned',
  catalogue_order_not_imported_banner:
    "The catalogue has not been imported yet: the order shown is the export file's current order. A manual reorder only stays in place until the next catalogue master import.",
  catalogue_order_inconsistent_title: 'Catalogue order is inconsistent',
  catalogue_order_inconsistent_banner:
    'The catalogue order is inconsistent and must be reported to technical support before reordering can continue. Cars involved: {ids}',
  catalogue_order_inconsistent_recheck: 'Recheck',
  catalogue_order_search_label:
    'Search by code, description, OEM or supplier product code',
  catalogue_order_search_button: 'Search',
  catalogue_order_search_next: 'Next',
  catalogue_order_search_too_short: 'Type at least 2 characters',
  catalogue_order_search_no_match: 'No match found',
  catalogue_order_search_matches: '{count} matches found',
  catalogue_order_search_matches_truncated:
    '{total} matches found (showing the first {returned})',
  catalogue_order_error_anchor_impossible:
    'The requested position is no longer valid: someone else changed this car in the meantime. Try dragging again.',
  catalogue_order_error_row_not_in_catalogue:
    'This product is no longer part of the export catalogue: the row has been refreshed.',
  catalogue_order_row_not_found:
    'This product could not be found: it may have dropped out of the export catalogue. Refresh the page.',

  // ── Existing supplier row — code lookup on edit (2026-09-15) ──────────────
  supplier_code_no_match_hint:
    'No catalogue product matches this code: price and barcode were left unchanged.',
  supplier_code_overwrite_confirm_title: 'Update supplier values?',
  supplier_code_overwrite_confirm_message:
    'A catalogue match was found for the new supplier code, with these values different from the current ones: {changes}. Overwrite them?',

  // ── Linked supplier codes — steal from another CATI product (2026-09-18) ──
  supplier_code_linked_option_caption: 'Linked to CATI {codes}',
  supplier_code_steal_product_line: 'CATI {cati_code} ({description})',
  supplier_code_steal_product_line_no_description: 'CATI {cati_code}',
  supplier_code_steal_confirm_title: 'Unlink this supplier code?',
  supplier_code_steal_confirm_title_strong:
    'WARNING: product(s) disappearing from the app',
  supplier_code_steal_confirm_ok: 'Unlink and use',
  supplier_code_steal_confirm_intro:
    'Supplier code "{code}" is already linked to: {products}.',
  supplier_code_steal_confirm_immediate:
    'Confirming removes the supplier immediately from whoever currently holds it, along with its price; this row will receive it only when you save or send.',
  supplier_code_steal_confirm_pending_note:
    'The pending update proposal of each product listed here (CATI {codes}) will also be changed accordingly.',
  supplier_code_steal_confirm_other_claim_note:
    "The code may still be listed in another product's pending update proposal not shown here: if so, it could reappear there at the next send.",
  supplier_code_steal_confirm_last_supplier_strong:
    'WARNING: for CATI {codes} this is the only remaining supplier. Not having been sent to Supermax yet, each product listed here will disappear from every screen and cannot be recovered from the app.',
  supplier_code_steal_success: 'Code unlinked and assigned to this row.',
  supplier_code_steal_success_with_proposal:
    'Code unlinked and assigned to this row. {notes}',
  supplier_code_steal_proposal_updated_line:
    "CATI {cati_code}'s pending proposal was updated: the supplier with code {code} was removed.",
  supplier_code_steal_proposal_updated_oem_note:
    " That supplier's own OE codes were also removed from the proposal.",
  supplier_code_steal_already_unlinked:
    'CATI {cati_code} had already lost this supplier code before this confirmation: the row received it anyway.',
  supplier_code_steal_links_changed_retry:
    'The list of linked products changed in the meantime: please check and confirm again.',
  supplier_list_min_error:
    'An active product must have at least one supplier. Only an inactive product may be left without suppliers.',

  // ── Removing every supplier — inactive products only (2026-09-30, task 031) ──
  supplier_list_reactivating_error:
    'The product is being reactivated: an active product must have at least one supplier.',
  suppliers_empty_inactive_hint:
    'No suppliers: allowed because the product is inactive. The product will stay saved with no suppliers and no prices.',
  suppliers_empty_combined_hint:
    'This submission will deactivate the product, but its suppliers will NOT be removed until Supermax has applied the deactivation (usually the next day, once the product shows as "Disattivo" on "Aggiorna prodotti"). You will need to re-propose the supplier removal afterwards.',
  suppliers_empty_state_hint:
    'No supplier linked to this product. Unlock the section to add one.',
  suppliers_remove_all_confirm_title: 'Remove every supplier?',
  suppliers_remove_all_confirm_message:
    "At send, every price (including future ones) and OE code of this product's suppliers will be deleted. Supermax is not told about the supplier removal.",
  suppliers_remove_all_confirm_message_combined:
    'This submission will deactivate the product, but its suppliers will NOT be removed until Supermax has applied the deactivation (usually the next day). Once the product shows as "Disattivo" on "Aggiorna prodotti", you will need to re-propose the supplier removal.',

  // ── "Aggiorna prodotti" list — inactive chip + suppliers column (task 031) ──
  updatable_search_label:
    'Search by CATI code, description, supplier product code or OEM',
  updatable_inactive_chip: 'Inactive',
  updatable_suppliers_column: 'Suppliers',

  // ── Update-proposal flow — EAN / Codice CATI read-only (2026-09-16) ───────
  update_readonly_no_channel_hint:
    'Not editable: never transmitted to Supermax.',

  // ── Update-proposal flow — car brand/model (2026-09-17) ───────────────────
  car_links_label: 'Car brand / model',
  car_links_hint:
    'The car link is applied only at send ("Esporta per Supermax"). A newly added model will appear at the bottom of its block in the supplier catalogue.',
  car_links_clear_confirm_title: 'Remove every car model?',
  car_links_clear_confirm_message:
    'At send, the product will lose every car link and will no longer appear in the supplier catalogue.',
}

export default carbody
